import React from 'react'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Typography,
  Chip,
  Divider,
  Grid,
} from '@mui/material'
import { UserManutencao } from '../../api/usuariosManutencao'

interface UsuarioManutencaoViewDialogProps {
  open: boolean
  onClose: () => void
  usuario: UserManutencao | null
}

const UsuarioManutencaoViewDialog: React.FC<UsuarioManutencaoViewDialogProps> = ({
  open,
  onClose,
  usuario,
}) => {
  if (!usuario) return null

  const getNivelName = (nivel: number | null) => {
    if (nivel === null) return 'N/A'
    switch (nivel) {
      case 0: return 'Super Admin'
      case 1: return 'Admin'
      case 2: return 'Gerente'
      case 3: return 'Supervisor'
      case 4: return 'Operador'
      case 5: return 'Padrão'
      default: return `Nível ${nivel}`
    }
  }

  const getNivelBadgeColor = (nivel: number | null) => {
    if (nivel === null) return 'default'
    switch (nivel) {
      case 0: return 'error'
      case 1: return 'primary'
      case 2: return 'success'
      case 3: return 'warning'
      default: return 'default'
    }
  }

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>Detalhes do Usuário</DialogTitle>
      <DialogContent>
        <Box sx={{ pt: 2 }}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <Typography variant="subtitle2" color="text.secondary">
                ID
              </Typography>
              <Typography variant="body1" gutterBottom>
                {usuario.id}
              </Typography>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Typography variant="subtitle2" color="text.secondary">
                Status
              </Typography>
              <Chip
                label={usuario.is_active ? 'Ativo' : 'Inativo'}
                color={usuario.is_active ? 'success' : 'default'}
                size="small"
                sx={{ mt: 0.5 }}
              />
            </Grid>
            <Grid item xs={12}>
              <Typography variant="subtitle2" color="text.secondary">
                Nome
              </Typography>
              <Typography variant="body1" gutterBottom>
                {usuario.name}
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography variant="subtitle2" color="text.secondary">
                Email
              </Typography>
              <Typography variant="body1" gutterBottom>
                {usuario.email}
              </Typography>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Typography variant="subtitle2" color="text.secondary">
                Login ThorJava
              </Typography>
              <Typography variant="body1" gutterBottom>
                {usuario.login_thor || '-'}
              </Typography>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Typography variant="subtitle2" color="text.secondary">
                ID Usuário ThorJava
              </Typography>
              <Typography variant="body1" gutterBottom>
                {usuario.iduser_thor || '-'}
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography variant="subtitle2" color="text.secondary">
                Nível de Acesso
              </Typography>
              <Chip
                label={getNivelName(usuario.nivel_acesso)}
                color={getNivelBadgeColor(usuario.nivel_acesso) as any}
                size="small"
                sx={{ mt: 0.5 }}
              />
            </Grid>
            <Grid item xs={12}>
              <Typography variant="subtitle2" color="text.secondary">
                Descrição do Usuário
              </Typography>
              <Typography variant="body1" gutterBottom sx={{ whiteSpace: 'pre-wrap' }}>
                {usuario.descricao_usuario || '-'}
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Divider sx={{ my: 1 }} />
            </Grid>
            <Grid item xs={12}>
              <Typography variant="subtitle2" color="text.secondary" gutterBottom>
                Grupos ({usuario.grupos.length})
              </Typography>
              <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5, mt: 1 }}>
                {usuario.grupos.length > 0 ? (
                  usuario.grupos.map((grupo) => (
                    <Chip key={grupo.id} label={grupo.nome} size="small" variant="outlined" />
                  ))
                ) : (
                  <Typography variant="body2" color="text.secondary">
                    Nenhum grupo vinculado
                  </Typography>
                )}
              </Box>
            </Grid>
            <Grid item xs={12}>
              <Typography variant="subtitle2" color="text.secondary" gutterBottom>
                Empresas ({usuario.empresas.length})
              </Typography>
              <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5, mt: 1 }}>
                {usuario.empresas.length > 0 ? (
                  usuario.empresas.map((empresa) => (
                    <Chip
                      key={empresa.id}
                      label={empresa.nome}
                      size="small"
                      variant="outlined"
                      color="primary"
                    />
                  ))
                ) : (
                  <Typography variant="body2" color="text.secondary">
                    Nenhuma empresa vinculada
                  </Typography>
                )}
              </Box>
            </Grid>
            {(usuario.created_at || usuario.updated_at) && (
              <>
                <Grid item xs={12}>
                  <Divider sx={{ my: 1 }} />
                </Grid>
                {usuario.created_at && (
                  <Grid item xs={12} sm={6}>
                    <Typography variant="subtitle2" color="text.secondary">
                      Criado em
                    </Typography>
                    <Typography variant="body2" gutterBottom>
                      {new Date(usuario.created_at).toLocaleString('pt-BR')}
                    </Typography>
                  </Grid>
                )}
                {usuario.updated_at && (
                  <Grid item xs={12} sm={6}>
                    <Typography variant="subtitle2" color="text.secondary">
                      Atualizado em
                    </Typography>
                    <Typography variant="body2" gutterBottom>
                      {new Date(usuario.updated_at).toLocaleString('pt-BR')}
                    </Typography>
                  </Grid>
                )}
              </>
            )}
          </Grid>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Fechar</Button>
      </DialogActions>
    </Dialog>
  )
}

export default UsuarioManutencaoViewDialog

